/*
 * @Description: 鼠标拖放指令
 * @Author: Xiaochun liu
 * @Date: 2024-03-07 11:34:15
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-07-05 17:08:50
 */
import type { DirectiveBinding } from 'vue'
import type { DirectiveDomElement } from '@/utils/dom/dom'

const dragDirective = {
  name: 'drag', // 指令名称，和组件名称一致
  mounted(el: DirectiveDomElement, binding: DirectiveBinding) {
    console.log('binding', binding)

    // 标记是否是拖动状态
    let isDragging = false

    // 拖拽时间标识
    let firstTime = 0
    let lastTime = 0

    let disX = 0
    let disY = 0

    let startX = 0
    let startY = 0

    el.style.position = 'fixed'
    el.style.zIndex = '2000'

    // 判断是否在屏幕左边或右边，如果不是，则移动到左边或右边
    const checkPosition = () => {
      // 移动过渡动画
      el.style.transition = 'left 0.2s'
      el.style.transitionTimingFunction = 'linear'

      const rect = el.getBoundingClientRect()
      const screenCenter = window.innerWidth / 2

      if (rect.left < screenCenter) {
        el.style.left = '0'
      } else {
        el.style.left = `${window.innerWidth - el.offsetWidth}px`
      }
    }

    const handleMouseDown = (e: MouseEvent) => {

      if (e.target.nodeName == 'INPUT' || e.target.nodeName == 'TEXTAREA') {
        return
      }

      isDragging = false
      firstTime = new Date().getTime()
      e.preventDefault()

      el.style.transition = 'none'
      el.style.transitionTimingFunction = 'none'

      disX = e.clientX - el.offsetLeft
      disY = e.clientY - el.offsetTop

      startX = e.clientX
      startY = e.clientY

      const handleMouseMove = (e: MouseEvent) => {
        isDragging = true
        const posX = e.clientX
        const posY = e.clientY

        let left = posX - disX
        let top = posY - disY

        const maxL = window.innerWidth - el.offsetWidth
        const maxT = window.innerHeight - el.offsetHeight

        left = left < 0 ? 0 : left
        left = left > maxL ? maxL : left

        top = top < 0 ? 0 : top
        top = top > maxT ? maxT : top

        el.style.left = `${left}px`
        // el.style.top = `${top}px`

        if (top < window.innerHeight / 2) {
          // 判断是否在屏幕上半部分
          el.style.top = `${top}px`
        } else {
          el.style.top = 'auto'
          // 如果是在屏幕下半部分，用bottom代替top
          el.style.bottom = `${window.innerHeight - top - el.offsetHeight}px`
        }

        // 判断下当前时间与初始时间差，大于200毫秒则判断状态为拖拽
        lastTime = new Date().getTime()

        if (lastTime - firstTime > 200) {
          isDragging = true
        } else {
          isDragging = false
        }
      }

      const handleMouseUp = (e: MouseEvent) => {
        const mouseDisX = e.clientX
        const mouseDisY = e.clientY
        const diffDisX = Math.abs(mouseDisX - startX)
        const diffDisY = Math.abs(mouseDisY - startY)

        if (!isDragging && diffDisX < 5 && diffDisY < 5) {
          binding.value.callback && binding.value.callback()
        }
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', handleMouseUp)

        if (binding.value.hasAdsorption) {
          // 拖放后需要靠边吸附
          checkPosition()
        }
      }

      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    }

    window.addEventListener('resize', checkPosition)

    el.addEventListener('mousedown', handleMouseDown)
  },
  unmounted(el: DirectiveDomElement) {
    // 判断是否在屏幕左边或右边，如果不是，则移动到左边或右边
    const checkPosition = () => {
      // 移动过渡动画
      el.style.transition = 'left 0.2s'
      el.style.transitionTimingFunction = 'linear'

      const rect = el.getBoundingClientRect()
      const screenCenter = window.innerWidth / 2

      if (rect.left < screenCenter) {
        el.style.left = '0'
      } else {
        el.style.left = `${window.innerWidth - el.offsetWidth}px`
      }
    }

    window.removeEventListener('resize', checkPosition)
  },
}

export default dragDirective
